// sekcja statystyk firmy (Wise UI) - placeholder CMS {{CompanyStats}}

import React, { FC, useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BoxSeam, Cart, House, People, Tag } from 'react-bootstrap-icons';

import { Container } from 'components/controls';

import styles from 'theme/components/wise/WiseCompanyStats/WiseCompanyStats.module.scss';

const WiseCompanyStats: FC = () => {
  const { t } = useTranslation();

  const stats = useMemo(
    () => [
      {
        key: 'products',
        icon: <BoxSeam aria-hidden />,
        value: '30 000',
        label: t('produktów')
      },
      {
        key: 'years',
        icon: <House aria-hidden />,
        value: '12',
        label: t('wiseCompanyStats.yearsOnMarket')
      },
      {
        key: 'ordersTag',
        icon: <Tag aria-hidden />,
        value: '600 000',
        label: t('wiseCompanyStats.orders')
      },
      {
        key: 'ordersCart',
        icon: <Cart aria-hidden />,
        value: '600 000',
        label: t('wiseCompanyStats.orders')
      },
      {
        key: 'clients',
        icon: <People aria-hidden />,
        value: '10 000',
        label: t('wiseCompanyStats.satisfiedClients')
      }
    ],
    [t]
  );

  return (
    <div
      className={classnames(styles.componentWrapper, 'StylePath-Components-wise-WiseCompanyStats')}>
      <section className={styles.section} aria-labelledby="wise-company-stats-title">
        <Container>
          <h2 className={styles.title} id="wise-company-stats-title">
            {t('wiseCompanyStats.title')}
          </h2>
          <div className={styles.grid}>
            {stats.map((row) => (
              <article key={row.key} className={styles.item}>
                <div className={styles.iconWrap}>{row.icon}</div>
                <div className={styles.info}>
                  <p className={styles.value}>{row.value}</p>
                  <p className={styles.label}>{row.label}</p>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
};

export default WiseCompanyStats;
